export interface AuthBootstrapContext {
  sapHost: string;
}

export interface OutboundDialEventDetail {
  phone: string;
  contactId?: string;
}

export const OUTBOUND_DIAL_EVENT = 'outbound-dial-initiated';
